import { render, staticRenderFns } from "./ProductReplacementTable.vue?vue&type=template&id=710504d4&"
import script from "./ProductReplacementTable.vue?vue&type=script&lang=js&"
export * from "./ProductReplacementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports